import { render, staticRenderFns } from "./VendaConjuntaVendasProdutos.vue?vue&type=template&id=405581c8&"
import script from "./VendaConjuntaVendasProdutos.vue?vue&type=script&lang=js&"
export * from "./VendaConjuntaVendasProdutos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDivider,VSimpleTable})
